import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Validated at import time (src/env.ts) — before App, and everything App imports, ever runs.
import '@/env';
import App from '@/App';
import '@/index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
